module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isEmpty) ? _c('div', [_vm._v("No meta data defined")]) : _vm._e(), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, _vm._l((_vm.metaData), function(val, key) {
    return _c('el-form-item', {
      key: key,
      attrs: {
        "label": key
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea"
      },
      on: {
        "input": _vm.updateValue
      },
      model: {
        value: (_vm.value[key]),
        callback: function($$v) {
          _vm.$set(_vm.value, key, $$v)
        },
        expression: "value[key]"
      }
    })], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e314b7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/MetaData.vue
// module id = 551
// module chunks = 1